/* eslint-disable no-shadow */
export enum SiteGroupsQueryKeys {
  GetAll = 'siteGroups/getAll',
  GetOneById = 'siteGroups/getById',
  Create = 'siteGroups/create',
  Edit = 'siteGroups/edit',
  Delete = 'siteGroups/delete',
  Breadcrumb = 'siteGroups/breadcrumb',
  SearchAnalytics = 'siteGroups/searchAnalytics',
  SitesAutocomplete = 'siteGroups/sitesAutocomplete',
}
